/**
 * The denied-input-VAT acknowledgement on the slip review screen (see
 * SlipReview.jsx) belongs to one exact (slip, account, tax code)
 * combination — a bookkeeper ticking "yes, this client genuinely claims it"
 * for THIS slip's THIS pairing must never carry over to a different slip, or
 * a different pairing on the same slip.
 *
 * A boolean acknowledgement reset by a `useEffect` keyed on
 * `[accountId, taxCodeId]` looks equivalent and is not: React bails out of
 * an effect whose dependencies are referentially equal to last render's, so
 * when two CONSECUTIVE slips propose the same account+tax-code pair — the
 * Zappas-history case this whole feature exists for — the effect never
 * re-fires, and a tick left over from the previous slip silently
 * authorises the next post with no fresh acknowledgement at all.
 *
 * Keying the acknowledgement itself, rather than resetting a boolean,
 * removes the failure mode structurally: there is no reset to forget to
 * run, because there is nothing that needs resetting. The acknowledgement
 * IS the key; it can only ever match the exact combination it was given
 * for.
 */
export const ackKey = (slipId, accountId, taxCodeId) => `${slipId ?? ''}:${accountId ?? ''}:${taxCodeId ?? ''}`;
